import LoadContext from "./LoadContext";
import { useState } from "react";

 function LoadContextProvider({children}) {
    const [loading,setLoading] = useState(false); 
  return (
    <LoadContext.Provider value={{loading,setLoading}}>
      {children}
    </LoadContext.Provider>
  )
}
export default LoadContextProvider;